import { updateGroup } from "../api/group";
import { ROUTES } from "./constants";

export function formatTime(time) {
	if (!time) return ` 0' 00"`;
	else
		return `${Math.floor(time / 60)}' ${
			time - Math.floor(time / 60) * 60
		}"`;
}

export function formatMinutes(time, timeout, finished) {
	if (time === undefined || isNaN(time) || finished) return "00";
	let remaining = (timeout - time) / 60;
	if (remaining <= 0) return "00";
	return (remaining < 10 ? "0" : "") + Math.floor(remaining);
}
export function formatSeconds(time, timeout, finished) {
	if (time === undefined || isNaN(time) || finished) return "00";
	let remaining = (timeout - time) % 60;
	if (remaining < 0) return "00";
	return (remaining < 10 ? "0" : "") + remaining;
}

export function updateTimer(value) {
	localStorage.setItem("total", value);
}

export function getTimer() {
	return localStorage.getItem("total");
}

const LAST_TICK_KEY = "lastTick";
export function setLastTickNow() {
  localStorage.setItem(LAST_TICK_KEY, String(Date.now()));
}
export function setLastTick(tsMs) {
  localStorage.setItem(LAST_TICK_KEY, String(tsMs));
}
export function getLastTick() {
  const v = localStorage.getItem(LAST_TICK_KEY);
  return v ? Number(v) : null;
}
export function clearLastTick() {
  localStorage.removeItem(LAST_TICK_KEY);
}

export function clearItem(item) {
	localStorage.removeItem(item);
}

export function hasTimerStarted() {
	const v = localStorage.getItem("total");
	return v !== null && Number(v) > 0;
}

const GROUP_ID_KEY = "groupId";

export function getGroupId() {
	return localStorage.getItem(GROUP_ID_KEY);
}

export function setGroupId(groupId) {
	if (groupId) localStorage.setItem(GROUP_ID_KEY, groupId);
	else localStorage.removeItem(GROUP_ID_KEY);
}

export function getGroupTable() {
	return localStorage.getItem("groupTable");
}

export function setGroupTable(groupTable) {
	localStorage.setItem("groupTable", groupTable);
}

/**
 * Limpia datos de sesión de la tablet en localStorage (equipo, mesa, cronómetro).
 * No borra idioma ni la caché de medios del navegador (vídeos/imágenes ya descargados siguen en disco).
 */
export function clearTabletLocalSession() {
	localStorage.removeItem(GROUP_ID_KEY);
	localStorage.removeItem("groupTable");
	localStorage.removeItem("total");
	localStorage.removeItem(LAST_TICK_KEY);
}

export async function updateStats(group) {
	await updateGroup(group?._id, group);
}

export function getScenarioNumByPath(path) {
	let scenario0Paths = [ROUTES.START_GAME,ROUTES.START_GAME2,ROUTES.START_GAME3,ROUTES.START_GAME4,ROUTES.START_GAME5];
	let scenario1Paths = [
		ROUTES.SCENARIO1_INSTRUCTIONS,
		ROUTES.SCENARIO1_INTRO,
		ROUTES.SCENARIO1_INTRO2,
	];

	let scenario2Paths = [
		ROUTES.SCENARIO2_INTRO,
		ROUTES.SCENARIO2,
		ROUTES.SCENARIO2_INTRO2,
		ROUTES.SCENARIO2_RESULTADOPETCT,
		ROUTES.SCENARIO2_RETROALIMENTACION,
		ROUTES.SCENARIO2_CLASIFICACION,
		ROUTES.SCENARIO2_ALTOVOLUMEN,
		ROUTES.SCENARIO2_METASTASIS,
		ROUTES.SCENARIO2_MUJER,
		ROUTES.SCENARIO2_FIN,
	];

	let scenario3Paths = [
		ROUTES.SCENARIO3_INTRO,
		ROUTES.SCENARIO3,
		ROUTES.SCENARIO3_FINALOSRESULTS,
		ROUTES.SCENARIO3_PEACEI,
		ROUTES.SCENARIO3_ANTECEDENTES,
		ROUTES.SCENARIO3_EVALUACION,
		ROUTES.SCENARIO3_BIESPECIFICOS,
		ROUTES.SCENARIO3_DESAFIO,
		ROUTES.SCENARIO3_PISTAEVALUACIONGERIATRICOS,
		ROUTES.SCENARIO3_EVALUACIONGERIATRICOS,
		ROUTES.SCENARIO3_ESCALAGERIATRICA,
		ROUTES.SCENARIO3_RETROALIMENTACION,
		ROUTES.SCENARIO3_FIN,
		ROUTES.SCENARIO3_FIN2,
	];

	let scenario4Paths = [
		ROUTES.SCENARIO4_INTRO,
		ROUTES.SCENARIO4,
		ROUTES.SCENARIO4_SUSPENSIONTRATAMIENTO,
		ROUTES.SCENARIO4_RETROALIMENTACION,
		ROUTES.SCENARIO4_RADIOTERAPIA,
		ROUTES.SCENARIO4_PREGUNTA9,
		ROUTES.SCENARIO4_FIN,
	];

	let scenario5Paths = [
		ROUTES.SCENARIO5_INTRO,
		ROUTES.SCENARIO5,
		ROUTES.SCENARIO5_SEGUIMIENTO2,
		ROUTES.SCENARIO5_APALUTAMIDA,
		ROUTES.SCENARIO5_RETROALIMENTACION,
		ROUTES.SCENARIO5_IMPACTO,
		ROUTES.SCENARIO5_CONCLUSION,
		ROUTES.SCENARIO5_RESULTADOS,
		ROUTES.SCENARIO5_FIN,
	];

	let supertestPaths = [
		ROUTES.SCENARIO5_END,
		ROUTES.SUPERTEST,
		ROUTES.SUPERTEST_2,
		ROUTES.SUPERTEST_3,
		ROUTES.SUPERTEST_INSTRUCTIONS,
		ROUTES.SUPERTEST_INTRO,
	];

	let allScenariosPaths = [ROUTES.FINAL_SCENE];

	if (scenario0Paths.includes(path)) return 0;
	else if (scenario1Paths.includes(path)) return 1;
	else if (scenario2Paths.includes(path)) return 2;
	else if (scenario3Paths.includes(path)) return 3;
	else if (scenario4Paths.includes(path)) return 4;
	else if (scenario5Paths.includes(path)) return 5;
	else if (supertestPaths.includes(path)) return 6;
	else if (allScenariosPaths.includes(path)) return 7;
}

export function getLocationAfterStampProgressScreen(stampNumber) {
	if (!stampNumber) return;
	if (stampNumber === 1) return ROUTES.SCENARIO1_EXTRA_INTRO;
	else if (stampNumber === 2) return ROUTES.SCENARIO2_EXTRA_INTRO;
	else if (stampNumber === 3) return ROUTES.TRANSITION_SCENARIOS;
	else if (stampNumber === 4) return ROUTES.SCENARIO4_EXTRA_INTRO;
	else if (stampNumber === 5) return ROUTES.SCENARIO5_END;
}
